

import React, { useRef, useEffect } from 'react';
import './hero.css';

import { init } from 'ityped';
import { Container, Row, Col } from 'reactstrap';
import HeroImg from '../../images/meto2.png';
import CV from '../../images/cv/cv.pdf';

const Hero = () => {
    
    const textRef = useRef();

    useEffect(() => {
        init(textRef.current, {
            backDelay:1500,
            showCursor: true,
            strings:[
                'Landry SAWA INGABIRE',
                'a Web designer',
                'a Web Developer',
                'a Content Editor',
                'a Data Analyst',
            ]
        }, [])
    })

  return (
    <section className='hero__section' id='home'>
        <Container>
            <Row>
                <Col md='6' lg='6'>
                    <div className="content">
                        <p className='mb-3'>Welcome To My World</p>
                        <h5 className='mb-4'>Hello Pipo !!! 🤜🤛 </h5>
                        <h2 className='hero-name mb-5'>I'm <span ref={textRef}></span></h2>
                        <p>
                            "Web development is often seen as a crazy world where the way you develop software
                            is by throwing hacks on top of hacks. I believe that React breaks from this pattern and
                            instead has been designed from first principle which gives you a solid foundation to
                            build on. <span className='hero-name2'>[ by Christoph Chedeau 'FB Eng.' ]</span>"
                        </p>

                        <div className="mt-5 hero-buttons d-flex align-items-center gap-4">
                            <button className="btn btn-cv">
                                <a href={CV} download>Hire me</a>
                            </button>
                            <button className="btn btn-cv"><a href="#contact">Contact Me</a></button>
                        </div>
                    </div>
                </Col>


                <Col md='6' lg='6'>
                    <div className="hero-image">
                        <img src={HeroImg} alt="Hero pic" className='w-100' />
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default Hero